import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user:null,
  token: null,
  registration:null
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser:(state,action)=>{
      state.user=action.payload
    },
    clearUser:(state)=>{
      state.user=null
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    clearToken: (state) => {
      state.token = null;
    },
    setRegistration:(state,action)=>{
       state.registration=action.payload;
    },
  },
});

export const { setToken, clearToken,setUser,clearUser,setRegistration } = userSlice.actions;
export const selectToken = (state) => state.user.token;
export const selectUser = (state) => state.user.user;
export const selectRegistration = (state) => state.user.registration;  // Changed from state.registration

export default userSlice.reducer;
